export default __webpack_public_path__ + "static/media/318.212954f1.gif";